import { Component, OnInit, Input, ViewChild, OnChanges } from "@angular/core";

import { Output, EventEmitter } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
} from "@angular/forms";
import {
  faGrid,
  faList,
  faArrowDownAZ,
  faArrowUpZA,
} from "@fortawesome/pro-light-svg-icons";
import { faSearch } from "@fortawesome/pro-regular-svg-icons";

import { CommonService } from "@services/common.service";
import { CanvasService } from "@services/canvas.service";
import { environment } from "../../../../environments/environment";

import { SelectionModel } from "@angular/cdk/collections";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { MatDialog } from "@angular/material/dialog";
import { MatSort, MatSortable } from "@angular/material/sort";
import { debounceTime } from "rxjs/operators";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
dayjs.extend(relativeTime);

import { ConfirmationDialogComponent } from "@dialogs/confirmation/confirmation.component";

@Component({
    selector: "app-schedule-list",
    templateUrl: "./schedule-list.component.html",
    styleUrls: ["./schedule-list.component.scss"],
    standalone: false
})
export class ScheduleCanvasListComponent implements OnInit, OnChanges {
  public canvasForm!: UntypedFormGroup;

  constructor(
    private canvasService: CanvasService,
    public commonService: CommonService,
    private fb: UntypedFormBuilder,
    public dialog: MatDialog
  ) {}

  @ViewChild(MatSort) sort!: MatSort;

  public canvas_listing: any[] = [];

  public p: number = 1;
  public breakpoint: number = 4;
  public display_data: string = "list";
  public status: boolean = true;
  public filtered_reports: any;
  public sort_view_asc: boolean = true;

  public totalCanvasObjectResults: number = 0;
  public canvasListLoaded = false;
  public direction = false;

  public fieldForm!: UntypedFormGroup;
  public error: string = "";
  public page: number = 1;
  public count: number = 20000;
  public dataFields: any[] = [];
  public canvasFields: any[] = [];
  public fieldItem: any;
  public data: any = [];

  showData = false;
  displayedColumns: string[] = ["select", "name", "type", "modified"];
  dataSetListing: any;
  existingDataFields: any;
  dataSource: any;
  selection = new SelectionModel<any>(true, []);
  filterValues: any = {};
  loading = false;
  timer: any;
  firstTime = true;

  openScheduledDialog(): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      disableClose: true,
      data: {
        message: "Cancel these " + this.selection.selected.length + " jobs?",
        actionButton: "cancel jobs",
      },
      panelClass: "canvas-dialog",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.removeSelectedRows();
      }
      // this.selection.clear();
    });
  }

  removeSelectedRows() {
    this.selection.selected.forEach((item) => {
      let index: number = this.data.findIndex((d: any) => d === item);

      this.data.splice(index, 1);
      this.dataSource = new MatTableDataSource<Element>(this.data);
    });
    this.selection = new SelectionModel<Element>(true, []);
  }

  getAllCanvasObjects() {
    this.canvasService
      .getAllScheduledCanvasObjects(13)
      .subscribe((data: any) => {
        this.canvasListLoaded = true;
        this.data = data.data;
        //console.log(data);
        this.dataSource = new MatTableDataSource(<any>data.data);
        this.selection = new SelectionModel<any>(true, []);
        this.showData = true;
      });
  }

  formatModified(time: string) {
    const displaydTIme = dayjs(time).format("dddd MMMM DD YYYY");
    return displaydTIme;
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.dataSource.data.forEach((row: any) => this.selection.select(row));
  }

  ngOnChanges() {
    this.selection.clear();
  }
  ngOnInit(): void {
    this.getAllCanvasObjects();
  }
}
